import { request } from "@util/request"
import {
  api_v1_payout_path,
  api_v1_payout_payout_distributions_path,
  api_v1_payout_payout_distribution_path,
  send_all_api_v1_payout_path,
  payout_api_v1_post_path,
} from "../routes"

function authHeaders(contentType = true): Record<string, string> {
  const token = localStorage.getItem("jwt_token")
  const csrf =
    (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)
      ?.content || ""
  const headers: Record<string, string> = { "X-CSRF-Token": csrf }
  if (contentType) headers["Content-Type"] = "application/json"
  if (token) headers["Authorization"] = `Bearer ${token}`
  return headers
}

export interface PayoutDistributionParams {
  band_id?: number
  pending_band_email?: string
  role?: string
  amount?: number
}

export async function getPayout(payoutId: number | string) {
  return request({
    queryKey: ["payout", { path: api_v1_payout_path(payoutId) }],
  })
}

export async function getPostPayout(postId: number | string) {
  return request({
    queryKey: ["post_payout", { path: payout_api_v1_post_path(postId) }],
  })
}

export async function addPayoutDistribution(
  payoutId: number | string,
  params: PayoutDistributionParams & { amount: number },
) {
  const response = await fetch(
    api_v1_payout_payout_distributions_path(payoutId),
    {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({ payout_distribution: params }),
    },
  )
  const data = await response.json()
  if (!response.ok) throw new Error(data.error || "Failed to add payee")
  return data
}

export async function updatePayoutDistribution(
  payoutId: number | string,
  distributionId: number,
  params: PayoutDistributionParams,
) {
  const response = await fetch(
    api_v1_payout_payout_distribution_path(payoutId, distributionId),
    {
      method: "PATCH",
      headers: authHeaders(),
      body: JSON.stringify({ payout_distribution: params }),
    },
  )
  const data = await response.json()
  if (!response.ok) throw new Error(data.error || "Failed to update payee")
  return data
}

export async function removePayoutDistribution(
  payoutId: number | string,
  distributionId: number,
) {
  const response = await fetch(
    api_v1_payout_payout_distribution_path(payoutId, distributionId),
    {
      method: "DELETE",
      headers: authHeaders(false),
    },
  )
  const data = await response.json()
  if (!response.ok) throw new Error(data.error || "Failed to remove payee")
  return data
}

export async function sendAllPayouts(payoutId: number | string) {
  const response = await fetch(send_all_api_v1_payout_path(payoutId), {
    method: "POST",
    headers: authHeaders(false),
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.error || "Failed to send payouts")
  return data
}
